/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/
$(function() {


  
/* FILTER＆SORT CLICK RELOAD */
$('.collection__sidebar input').on('click',function(){
setTimeout(function(){
		location.reload();
},800);
});

$('.popout-list').on('click',function(){
setTimeout(function(){
		location.reload();
},800);
});

/* HOVER COLLECTION */
function hoverinit(){
  $('.collection__products .grid-outer .grid .grid-item .product-item__bg__under').css('transition','none');
  $('.collection__products .grid-outer .grid .grid-item .product-item__bg').css('transition','none');
  $('.collection__products .grid-outer .grid .grid-item .product-item__swatches__holder').css('opacity','0');
  $('.collection__products .grid-outer .grid .grid-item .product-item__bg__under').css('opacity','0');
  $('.collection__products .grid-outer .grid .grid-item .product-item__bg').css('opacity','1');
  $('.collection__products .grid-outer .grid .grid-item .product-item__bg__under').css('display','block');
  $('.collection__products .grid-outer .grid .grid-item .product-item__bg').css('display','block');
}

if ($(window).width() <= 480) {
  $('.collection__products .grid-outer .grid .grid-item a').on({
    
    'mouseenter': function(event) {
        location.href =$(this).attr('href');
    },
    'mouseleave': function(event) {
         hoverinit();
    },
    'touchstart': function(event) {
         hoverinit();
         if ( $(this).children().hasClass('product-item__bg__under')){
             $(this).children('.product-item__bg__under, .product-item__bg').css({
                'transition': 'none',
                'opacity': function() { return $(this).is('.product-item__bg') ? 0 : 1; },
                'display': function() { return $(this).is('.product-item__bg') ? 'block' : 'block'; }
            });
         }
         $(this).parent().parent().find('.product-item__swatches__holder').css('opacity','1');
    },
    'touchend': function(event) {
         hoverinit();
    },
    'click': function(event) {
      location.href =$(this).attr('href');
    }
  
  });
}



});